module.exports = __webpack_public_path__ + "media/images/app/collections/collection-designer-mobile-db4df5eb7ef647e9128cdf337ca36f27.webp";